import { Redirect, useParams } from "wouter";
import { Cargando } from "@/components/ui";
import { useDatosApi } from "./DatosContext";
import { SobreTi } from "./secciones/SobreTi";
import { Diagnostico } from "./secciones/Diagnostico";
import { Rueda } from "./secciones/Rueda";
import { Flujo } from "./secciones/Flujo";
import { Balance } from "./secciones/Balance";
import { Objetivos } from "./secciones/Objetivos";
import { Identidad } from "./secciones/Identidad";
import { Proposito } from "./secciones/Proposito";
import { Estrategia } from "./secciones/Estrategia";
import { Portafolio4B } from "./secciones/Portafolio4B";
import { Sistema } from "./secciones/Sistema";

const MAPA = { "sobre-ti": SobreTi, diagnostico: Diagnostico, rueda: Rueda, flujo: Flujo, balance: Balance, objetivos: Objetivos, identidad: Identidad, proposito: Proposito, estrategia: Estrategia, portafolio: Portafolio4B, sistema: Sistema } as const;

export function SeccionRouter() {
  const { seccion } = useParams<{ seccion: string }>();
  const api = useDatosApi();
  if (api.cargando) return <Cargando texto="Cargando tus datos…" />;
  const C = MAPA[seccion as keyof typeof MAPA];
  if (!C) return <Redirect to="/datos" />;
  return <C />;
}
